// mindzera-frontend/src/AssignSeats.jsx
import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import api from './api.js';

const CURRENT_USER = '00000000-0000-0000-0000-000000000001';

export default function AssignSeats() {
  const { id: subscriptionId } = useParams();

  const [assignees, setAssignees] = useState([]);
  const [newUser, setNewUser] = useState('');
  const [error, setError] = useState('');

  const loadAssignees = () => {
    api
      .get(`/subscriptions/${subscriptionId}/assignees?user_id=${CURRENT_USER}`)
      .then(r => {
        const data = r.data;
        const arr = Array.isArray(data)
          ? data
          : Array.isArray(data.assignees)
            ? data.assignees
            : [];
        setAssignees(arr);
        setError('');
      })
      .catch(e => setError(e.response?.data?.error || e.message));
  };

  const assign = () => {
    if (!newUser.trim()) return;

    api
      .post(
        `/subscriptions/${subscriptionId}/assign?user_id=${CURRENT_USER}`,
        { user_id: newUser.trim() }
      )
      .then(() => {
        setNewUser('');
        loadAssignees();
      })
      .catch(e => setError(e.response?.data?.error || e.message));
  };

  const revoke = (userId) => {
    api
      .delete(
        `/subscriptions/${subscriptionId}/assign/${userId}?user_id=${CURRENT_USER}`
      )
      .then(loadAssignees)
      .catch(e => setError(e.response?.data?.error || e.message));
  };

  useEffect(loadAssignees, [subscriptionId]);

  return (
    <section className="p-4">
      <h1 className="text-xl mb-3">
        Manage seats for subscription {subscriptionId}
      </h1>

      {error && <p className="text-red-500 mb-2">{error}</p>}

      <ul className="mb-4">
        {assignees.length === 0 && <li>No assignees yet.</li>}
        {assignees.map(a => (
          <li key={a.user_id} className="flex justify-between mb-1">
            <span>{a.email || a.user_id}</span>
            <button
              onClick={() => revoke(a.user_id)}
              className="text-red-600 hover:underline"
            >
              Revoke
            </button>
          </li>
        ))}
      </ul>

      <div className="flex">
        <input
          type="text"
          placeholder="User ID"
          value={newUser}
          onChange={e => setNewUser(e.target.value)}
          className="border p-1 flex-grow mr-2"
        />
        <button
          onClick={assign}
          disabled={!newUser.trim()}
          className="bg-blue-600 text-white px-3 disabled:opacity-50"
        >
          Assign seat
        </button>
      </div>
    </section>
  );
}
